import { getCompanyInfoHook, AppContext } from '@nile/components';
import { TextStyle } from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';

const StripCell = (props) => {
  const { cell } = props;
  const data = cell?.value;
  const worklog = cell.row.original;
  const appContext = useContext(AppContext);

  // props required
  // 1. day (current day data from getDayDetails)
  // 2. hoursData
  // {

  // 3. daydata: current day data from getDayDetails,
  // date: date,
  // day: "September 25, 2023",
  // businessHourData: {
  //   timepent: "24.00",
  //   afterHours: false,
  // formattedTime: pass time spent to formatTime helper function
  // }
  // afterHourData: {
  //   timepent: "24.00",
  //   afterHours: true,
  // formattedTime: pass time spent to formatTime helper function
  // }

  // 4. displayValue : value we need to display in cell
  //  for this we can pass the value form api to formatTime
  // }

  let isHoliday = true;
  const companyInfo = getCompanyInfoHook();
  const businessHour = companyInfo?.businessHour;
  const dayData = data?.day;

  let totalWorkingHours = 24;

  const afterHoursWorked = data?.hoursData?.afterHoursData?.timespent
    ? parseFloat(data?.hoursData?.afterHoursData?.timespent)
    : null;

  const businessHoursWorked = data?.hoursData?.businessHoursData?.timespent
    ? parseFloat(data?.hoursData?.businessHoursData?.timespent)
    : null;

  const billableHoursWorked = data?.hoursData?.billableHours?.timespent
    ? parseFloat(data?.hoursData?.billableHours?.timespent)
    : null;

  const nonBillableHoursWorked = data?.hoursData?.nonBillableHours?.timespent
    ? parseFloat(data?.hoursData?.nonBillableHours?.timespent)
    : null;

  const isWorking24x7 = !businessHour || isEmpty(businessHour);
  if (!isWorking24x7) {
    const businessHourDay = businessHour?.find(
      (el) => el?.day === dayData?.day
    );
    if (businessHourDay) {
      isHoliday = false;
      const start = businessHourDay?.start;
      const end = businessHourDay?.end;

      const startHour = parseInt(start.split(':')[0]);
      const startMinute = parseInt(start.split(':')[1]);

      const endHour = parseInt(end.split(':')[0]);
      const endMinute = parseInt(end.split(':')[1]);

      const hourDifference = endHour - startHour;
      const minuteDifference = Math.abs(endMinute - startMinute) / 60;

      totalWorkingHours = hourDifference + minuteDifference;
    }
  }

  let businessHourPercent = 0;
  let billableHourPercent = 0;
  let nonBillableHourPercent = 0;

  if (businessHoursWorked > totalWorkingHours) {
    businessHourPercent = 100; // If totalHours is greater than working hours we'll take it as 100%
  } else {
    businessHourPercent = (businessHoursWorked / totalWorkingHours) * 100;
  }

  if (billableHoursWorked > totalWorkingHours) {
    billableHourPercent = 100; // If totalHours is greater than working hours we'll take it as 100%
  } else {
    billableHourPercent = (billableHoursWorked / totalWorkingHours) * 100;
  }

  if (nonBillableHoursWorked > totalWorkingHours) {
    nonBillableHourPercent = 100; // If totalHours is greater than working hours we'll take it as 100%
  } else {
    nonBillableHourPercent = (nonBillableHoursWorked / totalWorkingHours) * 100;
  }

  const WorkingDayGraphStyles = styled.div`
    width: 100%;
    align-items: center;
    display: flex;
    gap: 5px;
    padding: 10px;
    position: relative;
    cursor: pointer;
    .total-hours {
      width: 100%;
      border-radius: 2px;
      height: 30px;
      background-image: ${(props) =>
        props?.darkTheme
          ? 'none'
          : `url(${envConfig.imageRoot}svg/dashline-Pattern.svg)`};

      background-color: var(--sops-timesheet-worklog-bg);
    }
    .billable-hours {
      height: 30px;
      width: ${(props) =>
        props?.billableHourPercent ? `${props?.billableHourPercent}%` : '0%'};
      background: #bae5b5;
      border-radius: 2px;
      max-width: ${(props) => (props?.afterHoursWorked ? '80px' : '100%')};
    }

    .nonBillable-hours {
      height: 30px;
      width: ${(props) =>
        props?.nonBillableHourPercent
          ? `${props?.nonBillableHourPercent}%`
          : '0%'};
      background: #ede7ff;
      border-radius: 2px;
      max-width: ${(props) => (props?.afterHoursWorked ? '80px' : '100%')};
    }

    .after-hours {
      width: 15px;
      height: 30px;
      background: #f4aeb1;
    }

    .hours-worked {
      position: absolute;
      top: 15px;
      left: 20px;
    }
  `;

  // const HoursTippy = () => {
  //   return <>Hours Tippy</>;
  // };

  function handleClick() {
    if (worklog?.technician) {
      cell.column?.actions?.viewTechnician(worklog?.technician);
    }
  }

  const getHours = (duration) => {
    const hours = Math.floor(duration / 60);
    return hours;
  };
  const getMinutes = (duration) => {
    const minutes = Math.round(duration % 60);
    return minutes;
  };

  const formatTime = (time) => {
    const timeInMinutes = time * 60;
    return `${getHours(timeInMinutes)}h ${getMinutes(timeInMinutes)}m`;
  };

  return (
    <Tippy
      content={
        data?.displayValue && (
          <InfoPopupCardContainer className="br10">
            <div className="fx actr">
              <div className="billableHours mr-5" />
              <FormattedMessage id="timesheet.details.view.stat.billable.hours" />
              :{' '}
              <span className="mlauto">
                {formatTime(billableHoursWorked) || 'NA'}
              </span>
            </div>
            <div className="fx actr">
              <div className="nonBillableHours mr-5" />
              <FormattedMessage id="timesheet.details.view.stat.non.billable.hours" />
              :{' '}
              <span className="mlauto">
                {formatTime(nonBillableHoursWorked) || 'NA'}
              </span>
            </div>
            <div className="fx actr">
              <div className="afterHours mr-5" />
              <FormattedMessage id="timesheet.details.view.stat.after.hours" />:{' '}
              <span className="mlauto">
                {formatTime(afterHoursWorked) || 'NA'}
              </span>
            </div>
            <div className="fx actr total">
              <FormattedMessage id="timesheet.details.view.table.header.timespent" />
              :{' '}
              <span className="mlauto">
                {formatTime(data?.displayValue) || 'NA'}
              </span>
            </div>
          </InfoPopupCardContainer>
        )
      }
      delay={500}
      duration={250}
      interactive
      placement="right"
      arrow={false}
      theme="light"
      allowHTML
      appendTo={document.body}
    >
      <div onClick={handleClick}>
        {!data?.displayValue && (
          <WorkingDayGraphStyles>--</WorkingDayGraphStyles>
        )}

        {data?.displayValue && (
          <WorkingDayGraphStyles
            businessHourPercent={businessHourPercent}
            afterHoursWorked={afterHoursWorked}
            billableHourPercent={billableHourPercent}
            nonBillableHourPercent={nonBillableHourPercent}
            darkTheme={appContext?.darkTheme}
          >
            <div className="total-hours fx actr">
              <div className="billable-hours" />
              <div className="nonBillable-hours" />
              <span className="hours-worked">
                <TextStyle weight="Medium">
                  {formatTime(data?.displayValue)}
                </TextStyle>
              </span>
            </div>

            {afterHoursWorked ? <div className="after-hours" /> : <></>}
          </WorkingDayGraphStyles>
        )}
      </div>
    </Tippy>
  );
};

export { StripCell };

const InfoPopupCardContainer = styled.div`
  padding: 12px;
  min-width: 250px;
  max-width: 300px;
  max-height: 400px;
  overflow: scroll;
  position: relative;

  color: #0b0114;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;

  .mlauto {
    text-transform: lowercase;
  }

  & > div {
    margin-bottom: 10px;
  }

  .total {
    margin: 0;
    font-weight: 600;
    line-height: 20px;
    padding-top: 10px;
    border-top: 1px solid rgba(182, 179, 185, 0.15);
  }

  .billableHours,
  .nonBillableHours,
  .afterHours {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .billableHours {
    background: #bae5b5;
  }

  .nonBillableHours {
    background: #ede7ff;
  }

  .afterHours {
    background: #f4aeb1;
  }
`;
